import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { FieldSelect } from '../../components';

import css from './ShippingDelivery.module.css';

/**
 * DeliveryAddressSelect — lets users pick a saved address for delivery.
 *
 * Used on the checkout page when the listing supports delivery.
 * Reads addresses from `currentUser.protectedData.addresses`.
 *
 * @param {Array}  addresses  - list of user's saved addresses
 * @param {string} fieldName  - Final Form field name
 */
const DeliveryAddressSelect = ({ addresses = [], fieldName = 'deliveryAddressId' }) => {
  const intl = useIntl();

  if (addresses.length === 0) return null;

  return (
    <div className={css.deliverySection}>
      <p className={css.deliverySectionTitle}>
        <FormattedMessage id="DeliveryAddressSelect.title" />
      </p>
      <FieldSelect
        id={fieldName}
        name={fieldName}
        label={intl.formatMessage({ id: 'DeliveryAddressSelect.label' })}
      >
        <option value="">
          {intl.formatMessage({ id: 'DeliveryAddressSelect.noDelivery' })}
        </option>
        {addresses.map(addr => (
          <option key={addr.id} value={addr.id}>
            {addr.name} — {addr.street} {addr.streetNumber}, {addr.postalcode} {addr.city}
          </option>
        ))}
      </FieldSelect>
    </div>
  );
};

export default DeliveryAddressSelect;
